import "./MessageModals.scss";
import DeleteGif from "./../../assets/delete-gif.gif";
import RejectGif from "./../../assets/reject-gif.gif";
import AcceptGif from "./../../assets/accept-gif.gif";
import CloseIcon from "./../../assets/close-icon.svg";
import BlueButton from "../BlueButton/BlueButton";
import { message } from "antd";
import { FormControl, InputLabel, Modal, OutlinedInput } from "@mui/material";
import api from "../../utils/api";
import { useState } from "react";

const MessageModals = ({
  open,
  currentView,
  onClose,
  route,
  onDataChange,
  deleteMessage,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await api.delete(`${route}`);
      message.success(deleteMessage || "تم حذف المستخدم بنجاح");
      onDataChange();
    } catch (error) {
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const renderDeleteView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={DeleteGif} alt="" />
        <h4>هل أنت متأكد من الحذف</h4>
      </div>
      <div className="footer">
        <BlueButton
          text="حذف"
          onClick={handleDelete}
          size="medium"
          variant="fill"
          loading={loading}
        />
      </div>
    </div>
  );

  const renderRejectView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={RejectGif} alt="" />
        <h4>هل أنت متأكد من الرفض</h4>
      </div>
      <div className="footer">
        <BlueButton
          text="تاكيد"
          onClick={handleDelete}
          size="medium"
          variant="fill"
        />
      </div>
    </div>
  );

  const renderAcceptView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>

      <div className="body">
        <img src={AcceptGif} alt="" />
        <h4>هل أنت متأكد من الموافقة</h4>
      </div>
      <div className="footer">
        <BlueButton
          text="تاكيد"
          onClick={handleDelete}
          size="medium"
          variant="fill"
        />
      </div>
    </div>
  );

  const renderWithdrawalView = () => (
    <div
      className="container"
      style={{ justifyContent: "space-between", padding: "24px 10px" }}
    >
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>

      <h3>تسوية الرصيد</h3>
      <FormControl sx={{ width: "100%", padding: "0px" }} variant="outlined">
        <InputLabel
          htmlFor="outlined-adornment-password"
          shrink
          sx={{
            background: "white",
            transformOrigin: "right top",
            transform: "translate(14px, -9px) scale(0.75)",
            right: 24,
            left: "auto",
            paddingLeft: "4px",
            paddingRight: "4px",
          }}
        >
          المبلغ
        </InputLabel>
        <OutlinedInput
          sx={{ borderRadius: "8px" }}
          required
          id="outlined-adornment-password"
          type="text"
          notched
          placeholder="اكتب المبلغ"
        />
      </FormControl>

      <div className="footer">
        <BlueButton
          text="تاكيد"
          onClick={handleDelete}
          size="medium"
          variant="fill"
        />
      </div>
    </div>
  );

  const renderDefaultView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <h4>Default View</h4>
        <p>No specific view was selected.</p>
      </div>
      <div className="footer">
        <BlueButton
          text="Close"
          onClick={onClose}
          size="medium"
          variant="fill"
        />
      </div>
    </div>
  );

  const views = {
    delete: renderDeleteView,
    reject: renderRejectView,
    accept: renderAcceptView,
    withdrawal: renderWithdrawalView,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="message-modal"
    >
      {(views[currentView] || renderDefaultView)()}
    </Modal>
  );
};

export default MessageModals;
